<template>
  <section v-if="hasOutstanding" id="explore_area" class="section_padding_top">
    <div class="container">
      <!-- Section Heading -->
      <div class="row" v-if="hasOutstanding">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <div
            class="d-flex flex-wrap justify-content-between align-items-center gap-2"
          >
            <h2 class="text-coral mb-0" style="text-align: left">
              {{ $t("featured") }}
            </h2>
            <a
              class="text-coral"
              @click="showAllOutstanding = true"
            >
              {{ $t("view_more_properties") }}
          </a>
          </div>
          <br />
        </div>
      </div>
      <div class="row" v-if="hasOutstanding">
        <div class="col-lg-12">
          <div class="theme_nav_tab">
            <nav class="theme_nav_tab_item">
              <div class="nav nav-tabs">
                <button
                  v-for="(category, index) in filteredCategories"
                  :key="index"
                  :class="{
                    'nav-link': true,
                    active: selectedCategoryId == category.id,
                  }"
                  type="button"
                  @click="selectCategory(category)"
                  :style="index > 9 ? { margin: '10px' } : { margin: '5px' }"
                >
                  {{ $t(category.text) }}
                </button>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="tab-content" id="nav-tabContent">
            <div class="row">
              <div
                v-if="selectedCategory.length > 0"
                class="promotional_tour_slider owl-theme owl-carousel dot_style"
              >
                <swiper
                  :slides-per-view="4"
                  :space-between="20"
                  :pagination="{ clickable: true }"
                >
                  <swiper-slide v-for="(item, index) in selectedCategory" :key="index">
                    <div
                      class="tab-pane fade show active"
                      id="nav-hotels"
                      role="tabpanel"
                      aria-labelledby="nav-hotels-tab"
                    >
                      <div class="theme_common_box_two img_hover">
                        <div class="theme_two_box_img">
                      <router-link
                        target="_blank"
                        rel="noopener"
                        :to="buildLinkTo(item)"
                      >
                        <img :src="item.imagen" alt="img" />
                      </router-link>
                    </div>
                        <div class="theme_two_box_content my-1">
                          <h4 class="mx-3">
                        <router-link
                          target="_blank"
                          rel="noopener"
                          :to="buildLinkTo(item)"
                          >{{ item.name }}</router-link
                        >
                          </h4>
                          <h3 class="text-coral mx-3 my-2">
                            {{ item.price }}
                            <span class="text-black fs-4">{{ $t("per_night") }}</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <div v-else class="col-12">
                <div class="alert text-center">
                  {{ $t("no_properties_message") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showAllOutstanding"
        class="outstanding-modal-backdrop"
        @click.self="closeOutstandingPanel"
      >
        <div class="outstanding-modal card shadow-lg">
          <div class="modal-header border-0 align-items-center">
            <div class="headline-group mx-0 text-center">
              <h3 class="text-coral  mb-1 fw-bold">{{ $t("featured") }}</h3>
            </div>
          </div>
          <div class="modal-toolbar d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div class="d-flex flex-wrap gap-3 align-items-center">
              <span class="badge bg-light text-coral border border-coral rounded-pill px-3 py-2">
                {{ filteredOutstandingList.length }} {{ $t("properties_found") }}
              </span>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <button
                class="chip chip-action"
                type="button"
                @click="resetOutstandingFilters"
              >
                {{ $t("reset_filters") }}
              </button>
            </div>
          </div>
          <div class="modal-body pt-2">
            <div class="row align-items-start">
              <div class="col-lg-3 col-md-4 col-sm-12 mb-4">
                <div class="filters-panel card shadow-sm p-4">
                  <h5 class="fw-bold text-coral mb-1">{{ $t("filters") }}</h5>
                  <div class="filter-block mb-4">
                    <label class="form-label fw-semibold">
                      {{ $t("filter_by_categories") }}
                    </label>
                    <select class="form-select rounded-pill" v-model="filterCategoryId">
                      <option :value="null">{{ $t("select_category") }}</option>
                      <option
                        v-for="category in filteredCategories"
                        :key="`filter-${category.id}`"
                        :value="category.id"
                      >
                        {{ $t(category.text) }}
                      </option>
                    </select>
                  </div>
                  <div class="filter-block mb-4">
                    <label class="form-label fw-semibold mb-2">
                      {{ $t("filter_by_price") }}
                    </label>
                    <div class="price-range range-slider" v-if="priceOptions.length > 1">
                      <span class="rangeValues">{{ priceRangeDisplay }}</span>
                      <input
                        type="range"
                        class="form-range"
                        :min="0"
                        :max="priceOptions.length - 1"
                        step="1"
                        v-model.number="priceMinIndex"
                        @input="ensurePriceRangeOrder('min')"
                        list="price-steps"
                      />
                      <input
                        type="range"
                        class="form-range"
                        :min="0"
                        :max="priceOptions.length - 1"
                        step="1"
                        v-model.number="priceMaxIndex"
                        @input="ensurePriceRangeOrder('max')"
                        list="price-steps"
                      />
                      <datalist id="price-steps">
                        <option
                          v-for="(price, idx) in priceOptions"
                          :key="`price-step-${price}-${idx}`"
                          :value="idx"
                        ></option>
                      </datalist>
                    </div>
                    <div v-else class="text-muted small fst-italic">
                      {{ formatCurrency(priceOptions[0] ?? 0) }}
                    </div>
                  </div>
                  <button
                    class="chip chip-action w-100 rounded-pill"
                    type="button"
                    @click="resetOutstandingFilters"
                  >
                    {{ $t("reset_filters") }}
                  </button>
                </div>
              </div>
              <div class="col-lg-9 col-md-8 col-sm-12">
                <div class="properties-wrapper">
                  <div class="row g-4 outstanding-grid">
                  <div
                    v-if="filteredOutstandingList.length === 0"
                    class="col-12 text-center py-5"
                  >
                    {{ $t("no_properties_message") }}
                  </div>
                  <div
                    class="col-12 col-md-6 col-lg-4"
                    v-for="(item, index) in paginatedOutstandingList"
                    :key="`expanded-${item.id}-${index}`"
                  >
                    <div class="theme_common_box_two img_hover w-100 property-card">
                      <div class="theme_two_box_img">
                        <router-link
                          target="_blank"
                          rel="noopener"
                          :to="buildLinkTo(item)"
                        >
                          <img :src="item.imagen" alt="img" />
                        </router-link>
                      </div>
                      <div class="theme_two_box_content my-1">
                        <h4 class="mx-3">
                          <router-link
                            target="_blank"
                            rel="noopener"
                            :to="buildLinkTo(item)"
                          >
                            {{ item.name }}
                          </router-link>
                        </h4>
                        <p class="mx-3 mb-1 text-muted">
                          {{ $t("category") }}:
                          {{
                            $t(
                              filteredCategories.find(
                                (category) => category.id === item.category_id
                              )?.text ?? "category"
                            )
                          }}
                        </p>
                        <div class="price-pill mx-3 my-2">
                          <span class="text-coral fw-bold">{{ item.price }}</span>
                          <span class="text-black">{{ $t("per_night") }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <nav class="pagination-wrapper" v-if="totalPages > 1" aria-label="Outstanding pagination">
                  <ul class="pagination-list">
                    <li>
                      <button
                        class="pagination-control"
                        type="button"
                        :disabled="currentPage === 1"
                        @click="changePage(currentPage - 1)"
                        aria-label="Previous page"
                      >
                        «
                      </button>
                    </li>
                    <li v-for="page in paginationPages" :key="`page-${page}`">
                      <button
                        type="button"
                        class="pagination-number"
                        :class="{ active: currentPage === page }"
                        @click="changePage(page)"
                        :aria-current="currentPage === page ? 'page' : false"
                      >
                        {{ page }}
                      </button>
                    </li>
                    <li>
                      <button
                        class="pagination-control"
                        type="button"
                        :disabled="currentPage === totalPages"
                        @click="changePage(currentPage + 1)"
                        aria-label="Next page"
                      >
                        »
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import axios from "axios";
import { API_BASE_URL, OUTSTANDING_PROPERTIES_API, CATEGORIES_API } from "@/api-config";

export default {
  name: "OutstandingProperties",

  components: {
    Swiper,
    SwiperSlide,
  },

  data() {
    const currentDate = new Date();
    const startDate = new Date(currentDate);
    startDate.setDate(currentDate.getDate() + 1);
    const endDate = new Date(currentDate);
    endDate.setDate(currentDate.getDate() + 2);

    return {
      selectedCategoryId: null,
      items: [],
      categories: [],
      defaultStartDate: startDate.toISOString().slice(0, 10),
      defaultEndDate: endDate.toISOString().slice(0, 10),
      customerNationality: "CO",
      rooms: 1,
      guests: [{ adults: 1, children: [] }],
      showAllOutstanding: false,
      filterCategoryId: null,
      priceMinIndex: 0,
      priceMaxIndex: 0,
      priceRangeInitialized: false,
      currentPage: 1,
      perPage: 6,
    };
  },
  computed: {
    selectedCategory() {
      return this.items.filter(
        (category) => category.category_id == this.selectedCategoryId
      );
    },
    filteredCategories() {
      return this.categories.filter((category) =>
        this.items.some((item) => item.category_id === category.id)
      );
    },
    priceOptions() {
      const values = this.items
        .map((item) => this.getNumericPrice(item.price))
        .filter((value) => !Number.isNaN(value) && value >= 0);
      const unique = [...new Set(values)].sort((a, b) => a - b);
      return unique.length ? unique : [0];
    },
    selectedPriceRange() {
      const options = this.priceOptions;
      const minIdx = Math.min(this.priceMinIndex, options.length - 1);
      const maxIdx = Math.min(this.priceMaxIndex, options.length - 1);
      const minValue = options[Math.min(minIdx, maxIdx)] ?? 0;
      const maxValue = options[Math.max(minIdx, maxIdx)] ?? minValue;
      return [minValue, maxValue];
    },
    priceRangeDisplay() {
      const [minValue, maxValue] = this.selectedPriceRange;
      return `${this.formatSliderValue(minValue)} - ${this.formatSliderValue(maxValue)}`;
    },
    hasOutstanding() {
      return this.filteredCategories.length > 0;
    },
    filteredOutstandingList() {
      const categoryId =
        this.filterCategoryId === null || this.filterCategoryId === ""
          ? null
          : Number(this.filterCategoryId);
      let list = [...this.items];
      if (categoryId) {
        list = list.filter((item) => item.category_id === categoryId);
      }
      const [minPrice, maxPrice] = this.selectedPriceRange;
      list = list.filter((item) => {
        const value = this.getNumericPrice(item.price);
        return value >= minPrice && value <= maxPrice;
      });
      return list;
    },
    paginatedOutstandingList() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.filteredOutstandingList.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.max(Math.ceil(this.filteredOutstandingList.length / this.perPage), 1);
    },
    paginationPages() {
      const pages = [];
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
  },

  watch: {
    filteredCategories: {
      immediate: true,
      handler(newCategories) {
        if (!newCategories.length) {
          this.selectedCategoryId = null;
          return;
        }
        const stillValid = newCategories.some(
          (category) => category.id === this.selectedCategoryId
        );
        if (!stillValid) {
          this.selectedCategoryId = newCategories[0].id;
        }
      },
    },
    priceOptions: {
      immediate: true,
      handler(newOptions) {
        if (!newOptions.length) {
          this.priceMinIndex = 0;
          this.priceMaxIndex = 0;
          this.priceRangeInitialized = false;
          return;
        }
        if (!this.priceRangeInitialized) {
          this.priceMinIndex = 0;
          this.priceMaxIndex = newOptions.length - 1;
          this.priceRangeInitialized = true;
          return;
        }
        const lastIndex = newOptions.length - 1;
        this.priceMinIndex = Math.min(this.priceMinIndex, lastIndex);
        this.priceMaxIndex = Math.min(this.priceMaxIndex, lastIndex);
        if (this.priceMinIndex > this.priceMaxIndex) {
          this.priceMinIndex = this.priceMaxIndex;
        }
      },
    },
    filteredOutstandingList() {
      this.currentPage = 1;
    },
    showAllOutstanding(value) {
      if (value) this.currentPage = 1;
    },
  },

  mounted() {
    this.fetchCategories();
    this.fetchPropertyOutstanding();
  },
  methods: {
    selectCategory(category) {
      this.selectedCategoryId = category.id;
    },
    closeOutstandingPanel() {
      this.showAllOutstanding = false;
    },
    buildLinkTo(item) {
      return {
        name: `hotel-details`,
        params: { id: item.id, key: item.key },
        query: {
          start_date: this.defaultStartDate,
          end_date: this.defaultEndDate,
          rooms: this.rooms,
          guests: this.serializeGuests(this.guests),
          customerNationality: this.customerNationality,
        },
      };
    },
    resetOutstandingFilters() {
      this.filterCategoryId = null;
      this.priceMinIndex = 0;
      this.priceMaxIndex = this.priceOptions.length
        ? this.priceOptions.length - 1
        : 0;
    },
    ensurePriceRangeOrder(source) {
      if (this.priceMinIndex > this.priceMaxIndex) {
        if (source === 'min') {
          this.priceMaxIndex = this.priceMinIndex;
        } else {
          this.priceMinIndex = this.priceMaxIndex;
        }
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        maximumFractionDigits: 0,
      }).format(value ?? 0);
    },
    formatSliderValue(value) {
      return `${this.formatCurrency(value ?? 0)} k`;
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },
    getNumericPrice(priceString) {
      if (!priceString) return 0;
      const normalized = priceString
        .toString()
        .replace(/[^\d.,]/g, "")
        .replace(/\.(?=.*\.)/g, "")
        .replace(",", ".");
      const parsed = parseFloat(normalized);
      return Number.isNaN(parsed) ? 0 : parsed;
    },

    fetchCategories() {
      axios
        .get(`${API_BASE_URL}${CATEGORIES_API}`)
        .then((response) => {
          this.categories = response.data.results;
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        });
    },

    serializeGuests(guestsArray) {
      return guestsArray
        .map((guest) => `adults=[${guest.adults}],children=[${guest.children.join(",")}]`)
        .join("&");
    },

    fetchPropertyOutstanding() {
      axios
        .get(`${API_BASE_URL}${OUTSTANDING_PROPERTIES_API}`)
        .then((response) => {
          this.priceRangeInitialized = false;
          this.items = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching properties:", error);
        });
    },
  },
};
</script>
<style scoped>
.theme_common_box_two {
  width: 100%;
  max-width: 320px;
  height: max-content;
  border-radius: 15px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background-color: white;
  font-family: Arial, sans-serif;
  margin: 0 auto;
}
.theme_two_box_img img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
}
.alert {
  font-size: 30px;
  font-weight: bold;
}

:deep(.swiper-wrapper) {
    position: relative;
    width: 100%;
    height: auto;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
}

.view-more-btn {
  font-weight: 600;
  text-decoration: underline;
}

.modal-toolbar {
  border-bottom: 1px solid #f3f4f6;
  padding: 0.75rem 1.5rem 1.25rem;
  width: 100%;
}

.chip {
  background: #f7f7fb;
  color: #6c6f86;
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
  font-size: 0.85rem;
  border: none;
}

.chip-action {
  background: #ffecea;
  color: #ff6d63;
  border: none;
  cursor: pointer;
}

.border-coral {
  border-color: #ff6d63 !important;
}

.eyebrow {
  letter-spacing: 0.2em;
  font-size: 0.75rem;
}

.outstanding-modal-backdrop {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 1050;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 2rem 1rem;
  overflow-y: auto;
}

.outstanding-modal {
  max-width: 1200px;
  width: 100%;
  border-radius: 24px;
  margin: 2rem auto;
  padding: 0 1.5rem 2rem;
}

.modal-header {
  padding: 1.75rem 0 0.75rem;
  margin: 0 0.5rem;
  border-bottom: 1px solid #f3f4f6;
}

.filters-panel {
  border-radius: 20px;
  background: linear-gradient(145deg, #ffffff 0%, #f8f6ff 100%);
  border: 1px solid #f0eefc;
}

.filters-panel .form-select,
.filters-panel .form-control {
  border-radius: 10px;
}

.filters-panel .form-label {
  font-size: 0.9rem;
  color: #4a4a68;
}

.properties-wrapper {
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 0.75rem;
  margin-top: 0.5rem;
}

.outstanding-grid .theme_common_box_two {
  max-width: 100%;
}

.property-card {
  border: 1px solid #f1f1f5;
  padding-bottom: 0.5rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.property-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 35px rgba(0, 0, 0, 0.1);
}

.price-pill {
  background: #fff4f3;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.9rem;
}

.price-range {
  position: relative;
  width: 100%;
  text-align: center;
  padding: 0.5rem 0 1.75rem;
}

.price-range .rangeValues {
  display: block;
  margin-bottom: 0.75rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #4a4a68;
}

.price-range input[type='range'] {
  pointer-events: none;
  position: absolute;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  border: none;
  border-radius: 14px;
  background: #f1efef;
  box-shadow: inset 0 1px 0 0 #d8d6d6, inset 0 -1px 0 0 #e3e1e1;
  left: 0;
  width: 100%;
  height: 20px;
  top: 32px;
  margin: 0;
  padding: 0;
}

.price-range input[type='range']:last-of-type {
  background: none;
}

.price-range input[type='range']::-webkit-slider-thumb {
  pointer-events: all;
  position: relative;
  z-index: 2;
  outline: 0;
  -webkit-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 14px;
  background-image: linear-gradient(to bottom, #e5e5e5 0, #656565 100%);
  border: none;
}

.price-range input[type='range']::-moz-range-thumb {
  pointer-events: all;
  position: relative;
  z-index: 2;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 14px;
  background-image: linear-gradient(to bottom, #e5e5e5 0, #656565 100%);
  border: none;
}

.price-range input[type='range']::-ms-thumb {
  pointer-events: all;
  position: relative;
  z-index: 2;
  width: 20px;
  height: 20px;
  border-radius: 14px;
  border: 0;
  background-image: linear-gradient(to bottom, #e5e5e5 0, #656565 100%);
}

.price-range input[type=range]::-moz-range-track {
  position: relative;
  z-index: -1;
  background-color: rgba(0, 0, 0, 1);
  border: 0;
}

.price-range input[type=range]:last-of-type::-moz-range-track {
  -moz-appearance: none;
  background: transparent;
  border: 0;
}

.price-range input[type=range]::-moz-focus-outer {
  border: 0;
}

.pagination-wrapper {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
}

.pagination-list {
  list-style: none;
  display: flex;
  gap: 0.4rem;
  padding: 0;
  margin: 0;
}

.pagination-control,
.pagination-number {
  min-width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #d9deea;
  background: #fff;
  font-weight: 600;
  color: #334155;
  transition: all 0.2s ease;
}

.pagination-control:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pagination-number.active {
  background: #0d3564;
  color: #fff;
  border-color: #0d3564;
  box-shadow: 0 4px 10px rgba(13, 53, 100, 0.35);
}
</style>
